import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { formatDate, LOCALE_MAP } from 'utils/locale-formatting'
import styled from 'styled-components'
import { TransparencyPageHeader } from '../styles'

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

const LogoImg = styled.img`
  max-height: 64px;
  max-width: 200px;
  object-fit: contain;
`

const IconBox = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: color-mix(in srgb, var(--vo-capri) 20%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
`

const ShieldSvg = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="var(--vo-capri)">
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
  </svg>
)

const Inner = styled.div`
  position: relative;
  max-width: 640px;
  margin: 0 auto;
`

const Name = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-size: 32px;
  font-weight: 800;
  color: white;
  margin: 0 0 12px;
  letter-spacing: -.02em;
`

const Description = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  color: var(--vo-white-80);
  margin: 0 0 16px;
  line-height: 1.6;
`

const Caption = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: color-mix(in srgb, var(--vo-white) 50%, transparent);
  margin: 0;
`

export const TransparencyHeader = ({ name, description, lastUpdated, brandingLogoUrl }) => {
  const { t, i18n } = useTranslation('transparency')
  const locale = LOCALE_MAP[i18n.language] ?? 'en-US'
  return (
    <TransparencyPageHeader>
      <Inner>
        {brandingLogoUrl ? (
          <LogoWrapper>
            <LogoImg src={brandingLogoUrl} alt={`${name} logo`} />
          </LogoWrapper>
        ) : (
          <IconBox>
            <ShieldSvg />
          </IconBox>
        )}
        <Name>{name}</Name>
        {description && <Description>{description}</Description>}
        <Caption>
          {t('shared.transparencyCenter')}
          {lastUpdated && ` · ${t('shared.lastUpdated', { date: formatDate(lastUpdated, locale) })}`}
        </Caption>
      </Inner>
    </TransparencyPageHeader>
  )
}

TransparencyHeader.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  lastUpdated: PropTypes.string,
  brandingLogoUrl: PropTypes.string,
}
